// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"cc26fd2c","720":"7d4abcd1","894":"e703944a"}[chunkId] + ".chunk.css";
};